import {
  Avatar,
  Box,
  Button,
  Divider,
  Grid,
  Hidden,
  IconButton,
  InputAdornment,
  LinearProgress,
  MenuItem,
  Pagination,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import SearchIcon from '@mui/icons-material/Search';
import AddIcon from '@mui/icons-material/Add';
import { useJiffyStaffControllers } from './controller';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import FormJiffyStaffView from './Form';
import { numberFormat } from '../../utils/nunberFormat';
import StatusChip from '../../components/StatusChip';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmDialog from '../../components/ConfirmDialog';
import TabPanelActiveComponent from './components/tabPanel';
import TableSearchNotFound from '../../components/tableSearchNotFound';
import { useTranslation } from 'react-i18next';
import { IMAGE_MERCHANT_ROOT_URL } from '../../constants/imageUrl';

const JiffyStaffView = () => {
  const { t } = useTranslation("global");
  const controller = useJiffyStaffControllers();

  return (
    <>
      {controller.openForm ? (
        <FormJiffyStaffView
          onClose={controller.handleCloseForm}
          selectedData={controller.selectedData}
          onFetchData={controller.handleFetchData}
          setSelected={controller.setSelectedData}
        />
      ) : (
        <>
          <Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
              <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>
                {t("merchant_user_page.Merchant user")}
              </Typography>
              <Box>
                <TextField
                  placeholder={t("merchant_user_page.Username, Full name") || ""}
                  sx={{ maxWidth: 250 }}
                  fullWidth
                  value={controller.searchValue}
                  onChange={controller.handleSearch}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                />
              </Box>
              {/* <Box sx={{ ml: 2, width: 150 }}>
                <FormControl fullWidth size="small">
                  <Select value={controller.branchValue} onChange={(e) => controller.handleSelectedBranch(e.target.value)}>
                    {
                      controller.branchData.map((branch) => (
                        <MenuItem key={branch.id} value={branch.id}>
                          {i18n.language === EN_ACCEPT_LANGUAGE ? branch?.nameEn : branch?.nameLa}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              </Box> */}
            </Box>
            {/* show status bar */}
            <Box sx={{ mt: 2, display: 'flex' }}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{
                    backgroundColor: '#C4EAFF', borderRadius: '16px', p: 4, boxShadow:
                      '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                  }}>
                    <Box>
                      <Typography sx={{ mb: 1 }}>{t("merchant_user_page.All")}</Typography>
                      <Typography fontWeight="bold" fontSize={32}> {controller.rows.length}</Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{
                    backgroundColor: '#C8FACD', borderRadius: '16px', p: 4, boxShadow:
                      '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                  }}>
                    <Box>
                      <Typography sx={{ mb: 1 }}>{t("merchant_user_page.Active")}</Typography>
                      <Typography fontWeight="bold" fontSize={32}>{controller.rows?.filter((item) => item?.isBan === false)?.length}</Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{
                    backgroundColor: '#FFACB6', borderRadius: '16px', p: 4, boxShadow:
                      '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
                  }}>
                    <Box>
                      <Typography sx={{ mb: 1 }}>{t("merchant_user_page.Inactive")}</Typography>
                      <Typography fontWeight="bold" fontSize={32}>{controller.rows?.filter((item) => item?.isBan === true)?.length}</Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            {/* status bar */}
            <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, mb: 2 }}>
              <Button
                color='secondary'
                variant="contained"
                sx={{ textTransform: 'none', borderRadius: '8px', color: '#fff', width: 180 }}
                onClick={controller.handleOpenForm}
              >
                <AddIcon />
                &nbsp; {t("merchant_user_page.Create")}
              </Button>
            </Box>
            {
              controller.loadingData ? <LinearProgress /> : <>
                <Box
                  sx={{ mb: 2, mt: 2, background: '#F4F6F8', borderBottom: 1, borderColor: 'divider' }}
                >
                  <TabPanelActiveComponent value={controller.tabValue} onChange={controller.handleSetTabStatus} />
                </Box>
                <Box sx={{ mt: 2 }}>
                  <TableContainer>
                    <Table>
                      <TableHead sx={{ background: '#F4F6F8' }}>
                        <Hidden smUp>
                          <TableRow>
                            <TableCell sx={{ borderBottom: 'none' }}>{t("merchant_user_page.No")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }} align='left'>{t("merchant_user_page.Username")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }} align='center'>{t("merchant_user_page.Status")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                          </TableRow>
                        </Hidden>

                        <Hidden smDown>
                          <TableRow>
                            <TableCell sx={{ borderBottom: 'none' }}>{t("merchant_user_page.No")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>{t("merchant_user_page.Profile")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>{t("merchant_user_page.Full name")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }} align='left'>{t("merchant_user_page.Username")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>{t("merchant_user_page.Phone")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}>{t("merchant_user_page.Role")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }} align='center'>{t("merchant_user_page.Status")}</TableCell>
                            <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                          </TableRow>
                        </Hidden>
                      </TableHead>
                      <TableBody>
                        {
                          controller.rows?.map((row: any, index: number) => {
                            const { id, profile, username } = row;
                            const isActive: boolean = !row?.isBan;
                            return (
                              <>
                                <Hidden smDown>
                                  <TableRow key={index}>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                      {numberFormat(index + 1 + 10 * (controller.currentPage - 1))}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                      <Avatar src={IMAGE_MERCHANT_ROOT_URL + profile?.image?.url} />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                      {profile?.firstname} {profile?.lastname}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }} align='left'>
                                      {username}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                      {profile?.tel}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                      {t(row?.role_type)}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }} align='center'>
                                      <StatusChip status={isActive} />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }} align="right">
                                      <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, id, profile?.id)}>
                                        <MoreHorizIcon />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                </Hidden>
                                <Hidden smUp>
                                  <TableRow key={index}>
                                    <TableCell sx={{ borderBottom: 'none' }}>
                                      {numberFormat(index + 1 + 10 * (controller.currentPage - 1))}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }} align='left'>
                                      {username}
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }} align='center'>
                                      <StatusChip status={isActive} />
                                    </TableCell>
                                    <TableCell sx={{ borderBottom: 'none' }} align="right">
                                      <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, id, profile?.id)}>
                                        <MoreHorizIcon />
                                      </IconButton>
                                    </TableCell>
                                  </TableRow>
                                </Hidden>
                              </>
                            )
                          })
                        }
                      </TableBody>
                      {
                        controller.isSearchNotFound && (
                          <TableSearchNotFound
                            searchValue={controller.searchValue}
                            colSpan={9}
                          />
                        )
                      }
                    </Table>
                  </TableContainer>
                  <Divider sx={{ mt: 1, mb: 1 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Pagination color="primary" count={controller.countPagination} page={controller.currentPage} onChange={controller.handleChangePage} />
                  </Box>
                </Box>
                <Popover
                  open={Boolean(controller.openMenu)}
                  anchorEl={controller.openMenu}
                  onClose={controller.onCloseMenu}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  PaperProps={{
                    sx: {
                      p: 1,
                      width: 140,
                      '& .MuiMenuItem-root': {
                        px: 1,
                        typography: 'body2',
                        borderRadius: 0.75,
                      },
                    },
                  }}
                >
                  <MenuItem onClick={() => controller.handleOpenEditForm()}> <EditIcon /> &nbsp;&nbsp; {t("merchant_user_page.Edit")}</MenuItem>
                  <MenuItem sx={{ color: 'error.main' }} onClick={() => controller.handleOpenDeleteForm()}> <DeleteIcon /> &nbsp;&nbsp; {t("merchant_user_page.Delete")}</MenuItem>
                </Popover>
                <ConfirmDialog
                  open={controller.openDelete}
                  title={t("Do you want to delete data?")}
                  loading={controller.loadingDeleteButton}
                  onCancel={controller.handleCloseDeleteForm}
                  onConfirm={() => controller.handleDeleteUser()}
                />
              </>
            }

          </Box>
        </>
      )}
    </>
  );
};
export default JiffyStaffView;
